import SportsScoreIcon from '@mui/icons-material/SportsScore'
import { Button } from '@mui/material'
import { FC } from 'react'
import {
  BulkActionsToolbarProps,
  RaRecord,
  useRecordContext,
  useTranslate,
  useUpdate,
  useNotify,
  useRefresh,
} from 'react-admin'
import { ActionsToolbar } from '../../components'
import { xxllncColor } from '../../layout/themes'
import { ConversationOut } from '../../types/apiRequests'

interface CollaborationsShowActionsProps extends BulkActionsToolbarProps {
  data?: RaRecord
}

export const ConversationShowActions: FC<CollaborationsShowActionsProps> = (props) => {
  const translate = useTranslate()
  const record = useRecordContext<ConversationOut>(props)
  const id = record?.id
  const isClosed = false

  const [update, { isLoading }] = useUpdate()
  const notify = useNotify()
  const refresh = useRefresh()

  const onClick = () => {
    if (!id) return
    void update(
      'samenwerkingen',
      { id, data: { status: 'GESLOTEN' }, previousData: record },
      {
        onSuccess: () => {
          notify('Samenwerking succesvol gesloten', { type: 'success' })
          refresh()
        },
        onError: (error: any) => {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          notify(`Fout bij sluiten samenwerking: ${error?.message}`, { type: 'error' })
        },
      }
    )
  }

  return (
    <ActionsToolbar source="titel">
      <Button
        variant="outlined"
        endIcon={<SportsScoreIcon />}
        onClick={onClick}
        size="small"
        disabled={isClosed || isLoading}
        sx={{
          textTransform: 'none',
          fontSize: '0.875rem',
          fontWeight: 500,
          color: xxllncColor.dark100,
          borderRadius: '10px',
        }}
      >
        {isClosed ? translate('data.closed') : translate('data.complete')}
      </Button>
    </ActionsToolbar>
  )
}
